export default __webpack_public_path__ + "static/media/BackgroundNewer.47f6a5f2.png";